<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="2" y="2" width="28" height="28" rx="5" fill="#0D6A3E" />
    <rect x="6" y="7" width="12" height="1.8" rx="0.9" fill="white" />
    <rect x="6" y="12" width="18" height="1.8" rx="0.9" fill="white" />
    <rect x="6" y="17" width="10" height="1.8" rx="0.9" fill="white" />
    <path d="M7 24 Q11 20, 15 22 Q19 24, 23 20" stroke="#D97706" stroke-width="2.2" fill="none" stroke-linecap="round"/>
  </svg>
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
